module.exports = __webpack_public_path__ + "img/logs-icon-active.b3361781.svg";